import { ModelDistributionMetricsResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

export const getModelDistributionMetrics = async (
  orgId: string,
  labelIds?: string[],
): Promise<ModelDistributionMetricsResponse> => {
  const params = labelIds?.length
    ? '?' +
      labelIds.map((id) => `label_ids=${encodeURIComponent(id)}`).join('&')
    : '';

  const response = await apiRequest<ModelDistributionMetricsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/model-distribution${params}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch model distribution metrics');
  }

  return response.data;
};
